module.exports = __webpack_public_path__ + "img/1619.87b00edf.gif";